var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.71 115.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #131313;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.36,0h0C22.55,0,0,22.55,0,50.36h0c0,20.97,12.82,38.93,31.05,46.51.65.27,1.41-.04,1.68-.68,1.45-3.42,2.04-6.33,2.37-11.89h0c0-3.91-1.75-7.6-4.75-10.12-6.8-5.7-11.13-14.25-11.13-23.82,0-12.99,7.95-24.1,19.24-28.77v41.35h0v21.36c0,6.89-2.24,13.25-6.02,18.4-3.35,4.56-7.92,8.17-13.21,10.36.07.03.14.05.2.08.6.25,1.22.47,1.84.67.2.07.41.14.61.2.65.2,1.32.38,1.99.54.21.05.43.1.64.15.7.15,1.4.28,2.11.39.17.02.34.04.51.06.68.09,1.36.15,2.05.2.64.04,1.27.07,1.92.07,8.87,0,16.88-3.72,22.54-9.68,1.61-1.69,3.03-3.56,4.23-5.58,24.23-3.64,42.81-24.55,42.81-49.79h0C100.71,22.55,78.17,0,50.36,0ZM62.24,79.11V21.6c11.29,4.66,19.23,15.77,19.23,28.76s-7.95,24.1-19.23,28.76Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.5a8abb9275dfbac1d0c5a3906796f6ac.svg";
export { ForwardRef as ReactComponent };